module.exports = __webpack_public_path__ + "static/media/teenicon.099e9a1d.svg";